import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { MenuItemDropdown } from '../MenuItemDropdown/MenuItemDropdown';
import { MenuItemMessages } from '../MenuItemMessages/MenuItemMessages';
import { MenuItemSearch } from '../MenuItemSearch/MenuItemSearch';
import { MenuItemSegmentLink } from '../MenuItemSegmentLink/MenuItemSegmentLink';
import { MenuItemUser } from '../MenuItemUser/MenuItemUser';
import { StyledMenuComponentBase } from './MenuItem.styles';
import { MenuItemLink } from './MenuItemLink';

interface Props {
    onOpenChange: () => void;
    open: boolean;
    item: NavigationItem;
}

export const MenuItem: FC<Props> = ({ item, open, onOpenChange }) => {
    if (item.children?.length) {
        return <MenuItemDropdown item={item} open={open} onOpenChange={onOpenChange} />;
    }

    if (item.component) {
        switch (item.component) {
            case 'SEARCH':
                return <MenuItemSearch item={item} />;
            case 'SEGMENT_B2C':
            case 'SEGMENT_B2B':
            case 'SS_SEGMENT_LINK':
                return <MenuItemSegmentLink item={item} />;
            case 'MESSAGES':
                return <MenuItemMessages item={item} />;
            case 'USER':
                return <MenuItemUser item={item} />;
            default:
                return (
                    <StyledMenuComponentBase $colorOption={item.colorOption} $displayOption={item.displayOption}>
                        <div style={{ height: '100%', display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                            [{item.component}]
                        </div>
                    </StyledMenuComponentBase>
                );
        }
    }

    if (item.url) {
        return <MenuItemLink item={item} />;
    }

    return null;
};
